<template>
  <div class="Mpmaterial">
    <div id="materiallists" class="materiallist abcds">
      <div class="content">
        <div class="photo" :style="{
				height:width + 'px',
				width: width + 'px'
			}">
          <van-uploader :after-read="afterRead" accept="*"/>
        </div>
        <div :key="index" :style="{
                            height:width + 'px',
                            width: width + 'px'
			        }"
             class="materia-item"
             v-for="(item,index) in materialList">
          <div class="checkbox" @click="getselevt(item.checked,index)">
            <nut-checkbox v-model="item.checked"></nut-checkbox>
          </div>
          <lazy-component style="width:100%;height: 100%">
            <img v-if="'doc' === item.type" src="/static/images/menu_word_new.png"
                 style="width: 100%;height: 100%;">
            <img v-else-if="'audio' !== item.type"
                 :src="upFileUrl + (item.screenshotUrl === '' ? item.videoViewUrl : item.screenshotUrl)"
                 style="width: 100%;height: 100%;" @click.once="prImg(item)">
            <img v-else="" src="/static/images/msic.png"
                 style="width: 100%;height: 100%;">
          </lazy-component>
        </div>
      </div>
    </div>
    <div class="groupings">
      <div style="padding: 5px 7px;border: 1px solid #b9b9b9;border-radius: 5px;display: flex;align-items: center;"
           @click="Drawer">
        {{ groupingName }}
        <img src="/static/images/buttom.png" class="arrows">
      </div>
      <span style="display: inline-block;width: 10px"></span>
      <van-button type="info" size="small" @click="deletes">删除</van-button>
    </div>
    <van-popup
        v-model="show"
        position="left"
        :style="{ height: '100%',width: '50%' }"
    >
      <van-sidebar v-model="activeKey" @change="onChange">
        <van-sidebar-item v-for="(item,index) in tabbar" :title="item.name" :key="index"></van-sidebar-item>
      </van-sidebar>
    </van-popup>
    <van-overlay :show="show1">
      <div style="height: 100%;display: flex;justify-content: center;align-items: center">
        <van-loading size="24px" style="color: #F8F9FD">{{ msg }}...</van-loading>
      </div>
    </van-overlay>
    <van-overlay :show="show2">
      <div style="height: 100%;display: flex;justify-content: center;align-items: center">
        <div class="updata">
          <div class="updata-title">
            视频上传
          </div>
          <div class="updata-item">
            <label class="updata-item-left">文件名</label>
            <div class="updata-item-right">{{ fileName }}</div>
          </div>
          <div class="updata-item">
            <label class="updata-item-left">文件大小</label>
            <div class="updata-item-right">{{ fileSize }}M</div>
          </div>
          <div class="updata-item">
            <label class="updata-item-left">上传进度</label>
            <div class="updata-item-right">
              <nut-progress style="width: 100%"
                            :percentage="complete"
                            stroke-color="#1989fa"
                            :text-inside="true"
                            stroke-width="15"
              ></nut-progress>
            </div>
          </div>
          <div class="updata-item">
            <label class="updata-item-left"></label>
            <div class="updata-item-right" style="justify-content: flex-end">
              <van-button type="danger" size="small" @click="cancel">取消上传</van-button>
            </div>
          </div>
        </div>
        <!-- -->
      </div>
    </van-overlay>
    <van-image-preview v-model="imagesshow" :images="images">
    </van-image-preview>
  </div>
</template>

<script>
import {Dialog, Toast} from 'vant'
import qs from 'qs'
import axios from "axios"

export default {
  name: 'addImages',
  data() {
    return {
      width: 0,
      number: 0,
      selectImg: [],
      materia: [],
      show: false,
      tabbar: [],
      groupingName: '',
      activeKey: 0,
      materialList: [],
      allmaterialList: [],
      index: 0,
      isHasMore: true,
      isLoading: false,
      checked: '',
      id: 0,
      show1: true,
      FolderIndex: 0,
      msg: "加载中",
      imagesshow: false,
      images: [],
      show2: false,
      complete: 0,
      source: null,//取消上传
      fileName: "",
      fileSize: 0
    }
  },
  mounted() {
    this.width = document.getElementById('materiallists').clientWidth / 4 - 2
    this.getFolder(0)
    const materiallist = document.getElementsByClassName('abcds')[0]
    materiallist.addEventListener('scroll', this.handleScroll)
    this.selectImg = []
  },
  methods: {
    prImg(data) {
      const img = this.upFileUrl + (data.screenshotUrl === '' ? data.videoViewUrl : data.screenshotUrl)
      this.images[0] = img
      this.imagesshow = true
    },
    getselevt(sele, index) {
      this.materialList[index].checked = !sele
      this.$set(this.materialList, index, this.materialList[index])
      if (this.selectImg.includes(this.materialList[index])) {
        let i = this.selectImg.indexOf(this.materialList[index])
        this.selectImg.splice(i, 1)
      } else {
        this.selectImg.push(this.materialList[index])
      }

      this.number = this.selectImg.length
    },
    getFolder(index) {
      this.msg = "加载中"
      const p = new Promise((resolve, reject) => {
        this.$ajax.post('/etv/findAllOrOneFolder.json', qs.stringify({
          mtType: '',
          type: 'select',
          id: '',
        })).then(res => {
          if (res.data.code === 0) {
            resolve(res.data.data)
          } else {
            reject()
          }
        })
      })
      p.then(res => {
        this.tabbar = res.children

        this.groupingName = this.tabbar[index].name
        this.id = this.tabbar[index].mfId

        this.getmaterial(this.id)
      })
    },
    async deletes() {
      //把vuex里全选出来的数据存到this.clids和this.types，由于他们是应用的是同一个存储空间所以改变一个的值另一个也会改变
      this.clids = this.checkId

      let deleteObj = []

      if (this.selectImg.length < 1) {
        Toast("请选择素材")
        return
      }

      for (let i = 0; i < this.selectImg.length; i++) {
        let obj = {}
        obj.id = this.selectImg[i].mtId
        obj.type = "file"
        deleteObj.push(obj)
      }

      //查询素材是否绑定了节目和文件夹是否为空;ps:只能删除空文件夹;
      // eslint-disable-next-line no-unused-vars


      Dialog.confirm({
        title: '删除素材',
        message: '确认删除该素材？',
      }).then(() => {
        this.$ajax.post('/etv/deleteMtFolderOrMaterial.json', {
          "deleteObj": deleteObj
        }).then(res => {
          if (res.data.code == 0) {
            Toast(res.data.msg)
            this.materialList = []
            this.selectImg.length = 0
            this.getmaterial(this.tabbar[this.FolderIndex].mfId)
          } else {
            Toast(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })

      }).catch(() => {

      })
    },//删除文件或者文件夹
    Drawer() {
      this.show = true
    },
    onChange(index) {
      this.index = -1
      this.FolderIndex = index
      this.materialList = []
      this.groupingName = this.tabbar[index].name
      this.getmaterial(this.tabbar[index].mfId)
      this.id = this.tabbar[index].mfId
      this.show = false
      this.show1 = true
    },
    getmaterial(id) {
      this.$ajax.post('/etv/findAllMaterial.json', qs.stringify({
        id,
        type: '',
        pageNum: 1,
        pageSize: 99999,
      })).then(res => {
        if (res.data.code === 0) {

          this.allmaterialList = res.data.data.materialList
          this.allmaterialList.forEach(res => {
            res.checked = false
          })
         if(this.index === -1) this.index = 0
          this.materialList = this.allmaterialList.slice(this.index, this.index + 28)
          console.log(this.materialList);
          this.$nextTick(() => {
            this.show1 = false
          })
        }
      })
    },
    handleScroll() {

      //滚动条
      const scrollHeight = document.getElementsByClassName('abcds')[0].scrollTop
      let clientHeight = document.getElementsByClassName('content')[0].clientHeight
      let doch = document.getElementsByClassName('abcds')[0].clientHeight
      //真实高度
      if (clientHeight - doch - scrollHeight < 10) {

        if (this.allmaterialList.slice(this.index * 28, this.index * 28 + 28).length < 28) {
          return
        }
        console.log(159);
        this.index++
        this.materialList = [...this.materialList, ...this.allmaterialList.slice(this.index * 28, this.index * 28 + 28)]
      }
    },

    afterRead(file) {
      const imgTypes = ['png', 'jpg', 'jpeg', 'gif', "mp4", "avi", 'mov']

      if (imgTypes.includes(file.file.name.split('.')[file.file.name.split('.').length - 1].toLowerCase())) {
        this.show2 = true
        this.complete = 0
        const frromData = new FormData()

        this.fileName = file.file.name
        this.fileSize = file.file.size / 1024 / 1024

        frromData.append('files', file.file)
        frromData.append('id', this.id)

        let cancelToken = axios.CancelToken //Axios使我修改axios原型链了。
        this.source = cancelToken.source()

        this.$ajax.post(this.upFileUrl + 'etv/insertMaterial.json', frromData, {
          headers: {
            'contentType': 'multipart/form-data',
          },
          onUploadProgress: progressEvent => {
            var complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
            this.complete = complete
          },
          cancelToken: this.source.token,
        }).then(res => {
          if (res.data.code === 0) {
            this.materialList = []
            this.getFolder(this.FolderIndex)
            this.show2 = false
          } else {
            Toast(res.data.msg)
          }
        }).catch(() => {
          Toast("取消上传")
        })
      } else {
        Toast('图片格式错误')
      }
    },
    cancel() {
      if (this.source) {
        this.source.cancel('取消上传')
      }
      this.show2 = false
    },
  },
  destroyed() {
    this.materialList = []
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.Mpmaterial {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 55;
  background: #f1f1f1;

  .materiallist {
    width: 100%;
    padding: 2px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0px;
    bottom: 127px;
    overflow: auto;

    .content {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
    }

    .photo {
      box-sizing: border-box;
      padding: 2px;

      .van-uploader__upload-icon {
        font-size: 48px;
      }

      .van-uploader {
        width: 100%;
        height: 100%;
        border: none;

        .van-uploader__wrapper {
          width: inherit;
          height: inherit;

          .van-uploader__upload {
            width: inherit;
            height: inherit;
            margin: 0 !important;
            border: none;
          }
        }
      }

      .updata-centnt {
        width: 100%;
        height: 100%;
        border-radius: 5px;

        .updata {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          background: #ffffff;

          .updata-img {
            width: 40%;
            height: 40%;
            margin-bottom: 10px;
          }
        }
      }

    }


    .materia-item {
      position: relative;
      padding: 2px;
      box-sizing: border-box;

      .checkbox {
        position: absolute;
        top: 1px;
        left: 2px;
        display: flex;
        justify-content: center;
        align-items: center;

        checkbox {
          width: 25.42px;
          height: 25.42px;
        }
      }

      .image {
        width: 100%;
        height: 100%;
      }
    }
  }

  .groupings {
    display: flex;
    width: 100%;
    position: fixed;
    bottom: 77px;
    left: 0;
    height: 44px;
    align-items: center;
    padding-left: 20px;
    box-sizing: border-box;
    background: #F8F9FD;

    .arrows {
      height: 20px;
      width: 20px;
    }
  }

  .van-sidebar {
    width: 100%;
  }
}

.updata {
  background: #ffffff;
  width: 90%;
  border-radius: 5px;
  padding: 20px;
  box-sizing: border-box;

  .updata-title {
    height: 25px;
    margin-bottom: 10px;
    font-weight: 700;
  }

  .updata-item {
    display: flex;
    padding: 6px 0;

    .updata-item-left {
      width: 80px;
    }

    .updata-item-right {
      flex: 1;
      padding: 0 15px;
      display: flex;
      align-items: center;
      color: #8c8c8c;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

  }
}

</style>
